<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">

    <div v-if="!showDetails"
         class="layout-column flex ma-1"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">

      <div v-bind:style="{'z-index': '4'}" class="layout-row layout-align-center-center pa-1">
        <div class="layout-row">
          <lx-btn small classes="mr-1 text-none"
                  @click="getDataForTable()"
                  icon="refresh"
                  :tooltip="$t('ENCRYPTION_KEYS.BUTTONS.RELOAD')"
                  :disabled="tableObj.loading"
                  hide-label></lx-btn>
          <lx-btn block classes="mr-1 text-none"
                  width="125px"
                  @click="openEncryptionKeysDetails()"
                  icon="mdi-text-box-plus-outline"
                  :tooltip="$t('ENCRYPTION_KEYS.BUTTONS.ADD')"
                  :label="$t('ENCRYPTION_KEYS.BUTTONS.ADD')"></lx-btn>
        </div>

        <div class="flex"></div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="flex layout-column lx-delivery-background pa-1" style="overflow-y: hidden">

        <div class="elevation-3 flex layout-column pa-1" style="border-radius: 6px;"
             :style="{'background': compColor.lxExpansion.background}">
          <div style="border-radius: 6px;border: 1px solid rgba(0,0,0,0.1);" class="flex layout-column">
            <lx-data-table
              tableName="EncryptionKeysList"
              v-model="tableObj.selection"
              :items="items"
              :headers="tableObj.headers"
              :loading="tableObj.loading"
              :tableOptions="tableObj.options"
              :hideContextFilter="true"
              @changeOptions="changeTableOptions"
              @rowClicked="openEncryptionKeysDetails"
              @openContextOnRowClick="openContextOnRowClick">

              <template #cellrenderer="{ value }">
                <!-- icon renderer -->
                <div v-if="value.f.renderer === 'delete'" style="height:35px;" class="layout-column layout-align-center-center">
                  <v-icon
                    :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass"
                    size="20"
                    @click="openDeleteDialog(value.i, $event)"
                    style="cursor: pointer;">
                    mdi-delete-forever
                  </v-icon>
                </div>
              </template>
            </lx-data-table>
          </div>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="layout-row pa-0">
        <lx-pagination :page-name="'EncryptionKeysList'"
                       :page-options="pagingOptions"
                       :page-change="getDataForTable">
        </lx-pagination>
      </div>
    </div>

    <encryption-keys-details v-if="showDetails"
                             @set-show-details="setShowDetails"
                             :encryptionKeyId="selectedId">
    </encryption-keys-details>

  </div>
</template>
<script>
import EncryptionKeysDetails from './EncryptionKeyDetails'
import LxPagination from '../../../components/lx_pagination/LxPagination'

export default {
  name: 'EncryptionKeysList',
  data () {
    return {
      tableObj: {
        loading: false,
        selection: null,
        options: {
          sortBy: ['name'],
          sortDesc: [false]
        },
        headers: [
          {
            text: '',
            width: '20px',
            renderer: 'delete'
          },
          {
            text: this.$t('ENCRYPTION_KEYS.LIST_TABLE.NAME'),
            value: 'name',
            width: '300px',
            sortable: true
          },
          {
            text: this.$t('ENCRYPTION_KEYS.LIST_TABLE.KEY'),
            value: 'key',
            width: '150px',
            sortable: true
          },
          {
            text: this.$t('ENCRYPTION_KEYS.LIST_TABLE.PRIVATE_KEY_NAME'),
            value: 'privateKey.name',
            width: '200px'
          },
          {
            text: this.$t('ENCRYPTION_KEYS.LIST_TABLE.LAST_MODIFIED'),
            value: 'privateKey.lastModified',
            width: '200px',
            renderer: 'date'
          }
        ]
      },
      items: [],
      pagingOptions: {
        limit: 50,
        skip: 0,
        count: 0
      },
      showDetails: false,
      selectedId: null
    }
  },

  components: {
    EncryptionKeysDetails,
    LxPagination
  },

  created () {
    this.getDataForTable()
  },

  mounted () {
    if (typeof this.createCategory === 'function' && typeof this.addEntryToMenu === 'function') {
      this.createCategory('EncryptionKeysTable')
      this.addEntryToMenu({
        type: 'EncryptionKeysTable',
        value: [
          {
            icon: true,
            iconName: 'mdi-clipboard-edit-outline',
            title: 'Bearbeiten',
            action: this.openEncryptionKeysDetails
          },
          {
            icon: true,
            iconName: 'mdi-delete-forever',
            title: 'Löschen',
            action: this.openDeleteDialog
          },
        ]
      })
    }
  },

  methods: {
    openContextOnRowClick (event, item) {
      if (item) {
        this.$lxContext.open(event, 'EncryptionKeysTable', item, this.isLxContextDisabled)
      }
    },

    getDataForTable (options) {
      if (this.tableObj.loading) return
      this.tableObj.loading = true

      if (options && typeof options.skip === 'number') {
        this.pagingOptions.skip = options.skip
      }
      if (options && options.limit) {
        this.pagingOptions.limit = options.limit
      }

      let opts = {
        skip: this.pagingOptions.skip,
        limit: this.pagingOptions.limit
      }

      if (this.tableObj.options && this.tableObj.options.sortBy && this.tableObj.options.sortBy.length > 0) {
        opts.sort = {}
        opts.sort[this.tableObj.options.sortBy[0]] = this.tableObj.options.sortDesc[0] ? -1 : 1
      }

      this.$http.get('/encryptionKeys', { config: { opts: opts } })
        .then(res => {
          if (res.data) {
            this.items = res.data.items || []

            this.pagingOptions.count = res.data.count || 0
          }
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.tableObj.loading = false
        })
    },

    changeTableOptions (value) {
      if (value) {
        this.tableObj.options = value
      }
      this.getDataForTable()
    },

    openEncryptionKeysDetails (params) {
      this.selectedId = null

      if (params) {
        this.selectedId = params._id
      }
      this.setShowDetails(true)
    },

    openDeleteDialog (params, event) {
      if (event) {
        event.stopPropagation()
      }

      this.DialogConfirm(
        this.$t('CONFIRM_DELETE_DIALOG.HEADER'),
        this.$t('CONFIRM_DELETE_DIALOG.MESSAGE_DELETE_FORM'),
        { ok: this.$t('buttons.delete.value'), cancel: this.$t('buttons.cancel.value') })
        .then(() => {
          if (params) {
            this.$http.delete('/encryptionKeys/' + params._id)
              .then(() => {
                this.getDataForTable()
              })
              .catch(this.NotifyError)
          }
        })
        .catch(() => {
          // nothing to do
        })
    },

    setShowDetails (showDetails) {
      if (!showDetails) {
        this.getDataForTable()
      }
      this.showDetails = showDetails
    }
  },

  computed: {
    userIsRoot () {
      return this.authStore.getters.userIsAdmin
    },
  },

  watch: {
    '$route' (to) {
      if (to.name === 'EncryptionKeysList' && !this.showDetails) {
        // reload table
        this.getDataForTable()
      }
    }
  }
}
</script>
